import React from 'react';
import './index.less';

export interface IABSUISimpleContainerProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}
 
class ABSUISimpleContainer extends React.Component<IABSUISimpleContainerProps> {
  render() { 
    const { children, style } = this.props;
    return (
      <div className="absui-simple-container" style={style}>{children}</div>
    );
  }
}
 
export default ABSUISimpleContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSUISimpleContainer/index.tsx